import React from "react";

export function resetMobileViewportAfterLogin() {
  try {
    const el = document.activeElement;
    if (el && typeof el.blur === "function") el.blur();
  } catch (e) {}
  try {
    window.scrollTo(0, 0);
  } catch (e) {}
  try {
    const meta = document.querySelector('meta[name="viewport"]');
    if (meta) {
      const original = meta.getAttribute("content") || "width=device-width, initial-scale=1, viewport-fit=cover";
      meta.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, interactive-widget=resizes-content");
      setTimeout(() => {
        try {
          meta.setAttribute("content", original);
        } catch (e) {}
      }, 320);
    }
  } catch (e) {}
  try {
    const vv = window.visualViewport;
    if (vv && vv.scale && vv.scale !== 1) {
      setTimeout(() => {
        try {
          const meta = document.querySelector('meta[name="viewport"]');
          if (meta) {
            meta.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, interactive-widget=resizes-content");
            setTimeout(() => {
              try {
                meta.setAttribute("content", "width=device-width, initial-scale=1, viewport-fit=cover, interactive-widget=resizes-content");
              } catch (e) {}
            }, 220);
          }
        } catch (e) {}
      }, 30);
    }
  } catch (e) {}
}

export function useSessionViewportReset(session, activeFarmId) {
  React.useEffect(() => {
    if (!(session?.id || session?.role || session?.username)) return undefined;
    resetMobileViewportAfterLogin();
    const t1 = setTimeout(resetMobileViewportAfterLogin, 80);
    const t2 = setTimeout(resetMobileViewportAfterLogin, 260);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [session?.id, session?.role, session?.username, activeFarmId]);
}

export function useBeforeUnloadGuard() {
  React.useEffect(() => {
    const onBeforeUnload = (e) => {
      try {
        const bypassUntil = Number(window.__fzBypassBeforeUnloadUntil || 0);
        const bypassNow = !!window.__fzBypassBeforeUnload;
        const bootSplashVisible = !!window.__fzBootSplashVisible;
        const technicalUpdate = !!window.__fzTechnicalUpdateInProgress;
        if (bypassNow || technicalUpdate || bootSplashVisible || (bypassUntil && Date.now() <= bypassUntil)) return undefined;
      } catch (_) {}
      const message = "Tem certeza que deseja sair do app? Alterações não salvas podem ser perdidas.";
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    if (typeof window !== "undefined") window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      if (typeof window !== "undefined") window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, []);
}
